export const topics = [
  {
    id: 'topic-urban-renewal',
    title: '城市更新观察',
    description: '聚焦老旧小区改造、公共空间焕新与城市功能升级的系列深度报道。',
    cover:
      'https://readdy.ai/api/search-image?query=aerial%20view%20of%20modern%20city%20blocks%20with%20green%20parks%20and%20renovated%20neighborhoods%20soft%20warm%20light&width=640&height=440&seq=hs-topic-urban&orientation=landscape',
    tags: ['城市更新', '民生'],
  },
  {
    id: 'topic-ai-landing',
    title: 'AI 落地进行时',
    description: '记录大模型从实验室走向千行百业的真实场景与产业机会。',
    cover:
      'https://readdy.ai/api/search-image?query=abstract%20neural%20network%20visual%20over%20modern%20workspace%20deep%20blue%20gradient%20technology%20concept&width=640&height=440&seq=hs-topic-ai&orientation=landscape',
    tags: ['大模型', '人工智能'],
  },
  {
    id: 'topic-low-altitude',
    title: '低空经济崛起',
    description: '无人机物流、低空飞行网络与产业链上下游的完整图景。',
    cover:
      'https://readdy.ai/api/search-image?query=delivery%20drone%20flying%20over%20modern%20city%20logistics%20hub%20dusk%20sky%20clean%20composition&width=640&height=440&seq=hs-topic-lowalt&orientation=landscape',
    tags: ['低空经济', '无人机'],
  },
  {
    id: 'topic-stage-season',
    title: '秋季演出市场',
    description: '音乐节与线下演出全面回暖背后的产业逻辑与消费观察。',
    cover:
      'https://readdy.ai/api/search-image?query=outdoor%20music%20festival%20main%20stage%20with%20colorful%20lights%20and%20large%20crowd%20at%20night&width=640&height=440&seq=hs-topic-stage&orientation=landscape',
    tags: ['音乐节', '演出'],
  },
  {
    id: 'topic-chips',
    title: '芯片与算力',
    description: '先进制程、算力基础设施与国产替代的最新进展追踪。',
    cover:
      'https://readdy.ai/api/search-image?query=macro%20shot%20of%20semiconductor%20chip%20on%20blue%20circuit%20board%20with%20glowing%20traces%20high%20detail&width=640&height=440&seq=hs-topic-chip&orientation=landscape',
    tags: ['芯片', '算力'],
  },
  {
    id: 'topic-healthcare',
    title: '智慧医疗下沉',
    description: '基层医疗数字化升级与县域医共体建设的一线调研。',
    cover:
      'https://readdy.ai/api/search-image?query=bright%20modern%20community%20health%20clinic%20interior%20with%20medical%20equipment%20and%20warm%20lighting&width=640&height=440&seq=hs-topic-health&orientation=landscape',
    tags: ['医疗', '民生'],
  },
];